import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { LogOut, Shield } from "lucide-react";
import { useMemberAuth } from "../context/MemberAuthContext";
import { useAdminAuth } from "../context/AdminAuthContext";
import "./UserHeader.css";

const SwimmerIcon = ({ size = 16 }) => (
  <img 
    src="/favicon-2.ico" 
    alt="" 
    width={size} 
    height={size} 
    style={{ display: 'block' }}
  />
);

export default function UserHeader() {
  const { isAuthenticated: isMemberAuth, member, logout: memberLogout } = useMemberAuth();
  const { isAuthenticated: isAdminAuth, adminEmail, logout: adminLogout } = useAdminAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    if (isAdminAuth) {
      adminLogout();
    }
    if (isMemberAuth) {
      memberLogout();
    }
    navigate('/');
  };

  const isLoggedIn = isAdminAuth || isMemberAuth;
  const displayName = isAdminAuth 
    ? (adminEmail?.split('@')[0] || 'Admin')
    : (member?.first_name || 'My Account');
  const linkTo = isAdminAuth ? '/admin' : '/members';

  return (
    <div className="user-header">
      {isLoggedIn ? (
        <>
          <Link to={linkTo} className="user-header-link">
            {isAdminAuth ? <Shield size={16} /> : <SwimmerIcon size={16} />}
            <span>{displayName}</span>
          </Link>
          <button onClick={handleLogout} className="user-header-logout-btn" title="Log out">
            <LogOut size={16} />
          </button>
        </>
      ) : (
        <Link to="/members" className="user-header-link">
          <SwimmerIcon size={16} />
          <span>Member Login</span>
        </Link>
      )}
    </div>
  );
}
